import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import { GetImmediateChildrenAsync } from "source/app/services/Workflows/GetImmediateChildren";
import { GetWorkflowsState } from '../../presentation/MainPanel/Workflows/Workflows';
import { homeNode } from "motw_core/Repositories/WorkflowRepository";


export function ToggleSortMode() {
	if (SortModeIsOn()) {
		ResetSortSourceFirst();
	}

	SaveToggledSortMode();
}

export async function GetSortOrderAsync(parentNode: IWorkflowNode) {
	if (HasPrevioslySavedSortOrder(parentNode)) {
		return SavedSortOrder(parentNode);
	}

	return await CalculatedSortOrderAsync(parentNode);
}

const SortModeIsOn = () => {
	const workflows = GetWorkflowsState();
	return workflows.state.sortMode;
};

const ResetSortSourceFirst = () => {
	const workflows = GetWorkflowsState();
	workflows.setState({ sortSource: homeNode });
};

const SaveToggledSortMode = () => {
	const workflows = GetWorkflowsState();
	workflows.setState({ sortMode: !workflows.state.sortMode });
};

const HasPrevioslySavedSortOrder = (node: IWorkflowNode) => node.sortorder !== undefined;

const SavedSortOrder = (node: IWorkflowNode) => node.sortorder;

const CalculatedSortOrderAsync = async (node: IWorkflowNode) => {
	if (WorkflowsAreNotLoaded()) {
		return [];
	}

	const children = await GetImmediateChildrenAsync(node);
	const sortOrder = children.map((childNode) => childNode.id);
	return sortOrder;
};

const WorkflowsAreNotLoaded = () => GetWorkflowsState() === undefined;
